import React from 'react';
import { XIcon } from 'lucide-react';
const PROBLEMS = ['You spend hours preparing and adapting materials before teaching.', 'You constantly need activities for students with different support needs.', 'Your visual resources, worksheets, notes, and templates are scattered everywhere.', 'You need to differentiate the same activity for different learners.', 'You need practical tools for routines, communication, independence, and participation.', 'Your planning needs structure without creating more paperwork.'];
export function Problems() {
  return <section aria-labelledby="problems-title" className="w-full bg-white px-3 py-7 sm:px-5" data-id="element-171" data-mp="2o7clr36wwu66">
      <div className="mx-auto max-w-4xl text-center" data-id="element-172" data-mp="2j6ghupmk980r">
        <span className="font-head text-[10px] uppercase tracking-[0.14em] text-coral sm:text-xs" data-id="element-173" data-mp="2f5d366g91i14">
          The Special Education Teaching Reality
        </span>
        <h2 id="problems-title" className="mt-1 font-head text-2xl uppercase leading-[0.98] text-ink sm:text-4xl" data-id="element-174" data-mp="hch7q7l6cwpn">
          If you teach special education, you probably know these problems.
        </h2>

        <ul className="mx-auto mt-4 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-175" data-mp="39py65zbmmmpa">
          {PROBLEMS.map(item => <li key={item} className="flex items-start gap-2 rounded-lg border border-coral/25 bg-coral/5 px-3 py-2 text-[13px] leading-snug text-body" data-id="element-176" data-mp="2vq6ljfqlu82b">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-coral" aria-hidden="true" data-id="element-177" data-mp="2zsjqw31fw3yk" />
              {item}
            </li>)}
        </ul>

        <p className="mt-4 font-head text-lg uppercase leading-tight text-petrol sm:text-2xl" data-id="element-178" data-mp="3njp7ikf7f09x">
          How many more lessons do you want to keep building from scratch?
        </p>
      </div>
    </section>;
}